import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { useAuth } from "../../context/AuthContext";
import { formatApiError } from "../../lib/api";
import AuthShell, { googleLogin } from "./AuthShell";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(email, password);
      toast.success("Welcome back!");
      const intended = localStorage.getItem("wls_intended_plan");
      if (user.role === "admin") navigate("/admin");
      else if (intended) navigate("/pricing");
      else navigate("/portal");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Welcome back"
      subtitle="Log in to your client portal or admin dashboard."
      footer={<>Don't have an account? <Link to="/register" className="text-[#C9A227] font-medium">Create one</Link></>}
    >
      <Button data-testid="google-login-btn" type="button" variant="outline" onClick={googleLogin} className="w-full h-12 rounded-full border-white/20">
        <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="" className="h-5 w-5 mr-2" /> Continue with Google
      </Button>
      <div className="my-6 flex items-center gap-4 text-xs text-[#7E7663]">
        <div className="h-px flex-1 bg-slate-200" /> OR <div className="h-px flex-1 bg-slate-200" />
      </div>
      <form onSubmit={submit} className="space-y-4" data-testid="login-form">
        <div className="space-y-1.5">
          <Label>Email</Label>
          <Input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@business.com" required className="h-11" />
        </div>
        <div className="space-y-1.5">
          <Label>Password</Label>
          <Input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" required className="h-11" />
        </div>
        <Button data-testid="login-submit" type="submit" disabled={loading} className="w-full h-12 rounded-full bg-[#C9A227] hover:bg-[#B0891C] text-black">
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Log in"}
        </Button>
      </form>
    </AuthShell>
  );
}
